import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import logo_worded_only from '../assets/logo_worded_only.png';
import logo_icon from '../assets/logo_icon.png';
import { callApi, getCookie, setCookie } from "../Helpers";
import { MdArrowCircleRight } from "react-icons/md";
import {
  STR_CHANGE_LANGUAGE,
  STR_CONTINUE,
  STR_ENTER_OTP,
  STR_ENTER_YOUR_PHONE_NUMBER,
  STR_FORGOT_PASSWORD,
  STR_INVALID_OTP,
  STR_INVALID_PHONE,
  STR_PLEASE_WAIT,
  STR_RESEND_OTP,
  STR_WELCOME,
  STR_YOUR_PHONE,
  STR_PHONE_NUMBER,
  STR_YOUR_OTP_VERIFICATION,
  STR_CHANGE_PHONE,
  STR_INTRO_2
} from "../Strings";

export default function Login(props) {

  const appContext = useContext(AppContext);

  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [loginStep, setLoginStep] = useState("identity");

  async function init() {
    const storedPhone = getCookie("phone");
    const storedLoginStep = getCookie("loginStep");

    if (storedPhone) setPhone(storedPhone);
    if (storedLoginStep) setLoginStep(storedLoginStep);
  }

  async function resendOtp() {
    if (loading) {
      appContext.tellInfo(STR_PLEASE_WAIT[appContext.language]);
      return;
    }
    if (String(phone).trim().length < 9) {
      appContext.tellError(STR_INVALID_PHONE[appContext.language]);
      return;
    }
    setLoading(true);
    try {
      const response = await callApi("resend-otp", {
        phone: `255${parseInt(phone, 10)}`,
        identity: 'phone',
        email: ''
      });
      if (response.status === 1) {
        setCookie('phone', phone);
        setCookie('loginStep', response.nextLoginStep);
        setLoginStep(response.nextLoginStep);
      } else {
        appContext.tellError(response.msg);
      }
    } catch (err) {
      appContext.tellError("Network error. Please try again.");
    }
    setLoading(false);
  }

  async function phoneLogin() {
    if (loading) {
      appContext.tellInfo(STR_PLEASE_WAIT[appContext.language]);
      return;
    }
    if (String(phone).trim().length < 9) {
      appContext.tellError(STR_INVALID_PHONE[appContext.language]);
      return;
    }
    setLoading(true);
    try {
      const response = await callApi("phone-login", {
        phone: `255${parseInt(phone, 10)}`,
      });
      if (response.status === 1) {
        setCookie('phone', phone);
        setCookie('loginStep', response.nextLoginStep);
        setLoginStep(response.nextLoginStep);
      } else {
        appContext.tellError(response.msg);
      }
    } catch (err) {
      appContext.tellError("Network error. Please try again.");
    }
    setLoading(false);
  }

  async function forgotPassword() {
    if (loading) {
      appContext.tellInfo(STR_PLEASE_WAIT[appContext.language]);
      return;
    }
    if (String(phone).trim().length < 9) {
      appContext.tellError(STR_INVALID_PHONE[appContext.language]);
      return;
    }
    setLoading(true);
    try {
      const response = await callApi("forgot-password", {
        phone: `255${parseInt(phone, 10)}`,
        email: '',
        identity: 'phone',
      });
      if (response.status === 1) {
        setCookie('phone', phone);
        setCookie('loginStep', response.nextLoginStep);
        setLoginStep(response.nextLoginStep);
      } else {
        appContext.tellError(response.msg);
      }
    } catch (err) {
      appContext.tellError("Network error. Please try again.");
    }
    setLoading(false);
  }

  async function otpLogin() {
    if (loading) {
      appContext.tellInfo(STR_PLEASE_WAIT[appContext.language]);
      return;
    }
    if (otp.trim().length !== 6) {
      appContext.tellError(STR_INVALID_OTP[appContext.language]);
      return;
    }
    setLoading(true);
    try {
      const response = await callApi("otp-login", {
        phone: `255${parseInt(phone, 10)}`,
        otp,
        identity: 'phone',
        email: '',
      });
      if (response.status === 1) {
        setCookie('phone', '');
        setCookie('loginStep', '');
        setCookie("userId", response.user.id);
        setCookie("userToken", response.user.token);
        appContext.navTo({ item: 'request_ride' });
        appContext.refresh();
        appContext.tellMessage(STR_WELCOME[appContext.language]);
      } else {
        appContext.tellError(response.msg);
      }
    } catch (err) {
      appContext.tellError("Network error. Please try again.");
    }
    setLoading(false);
  }

  function renderShell(children) {
    return (
      <div
        className="vh-100 d-flex align-items-center justify-content-center px-3"
        style={{
          background:
            "linear-gradient(180deg,var(--surfaceColor), var(--surfaceColor),var(--secondaryColor))"
        }}
      >
        <div
          className="w-100"
          style={{
            maxWidth: "450px"
          }}
        >
          {children}
        </div>
      </div>
    );
  }

  function renderTopBrand() {
    return (
      <div className="text-center mb-4">

        <img
          src={logo_icon}
          alt="BA Rides"
          style={{
            width: 80,
            height: 80,
            objectFit: "contain"
          }}
        />

        <div className="mt-2">
          <img
            src={logo_worded_only}
            alt="BA Rides"
            style={{
              width: 160,
              maxWidth: "100%"
            }}
          />
        </div>

      </div>
    );
  }

  function renderCard(title, subtitle, body, footer) {
    return (
      <div
        className="card border-0 mShadow4"
        style={{
          borderRadius: "24px"
        }}
      >

        <div className="card-body p-4 p-md-5">

          <div className="text-center mb-4">

            <h3
              className="font-light text-primary mb-2"
              style={{
                fontSize: "28px",
                textTransform: "none"
              }}
            >
              {title}
            </h3>

            <div className="text-muted text-start mt-3">
              {subtitle}
            </div>

          </div>

          {body}

          {footer && (
            <div className="mt-4">
              {footer}
            </div>
          )}

        </div>

      </div>
    );
  }

  function renderPrimaryButton(label, onClick) {
    return (
      <button
        type="button"
        disabled={loading}
        onClick={onClick}
        className="btn btn-primary btn-block py-3 mt-3"
        style={{
          borderRadius: "14px"
        }}
      >
        {loading ? "Please wait..." : label}
      </button>
    );
  }

  function renderLinkRow(items) {
    return (
      <div className="d-flex flex-column gap-2 mt-3">

        {items.map((item, index) => (
          <button
            key={index}
            type="button"
            disabled={loading}
            onClick={item.onClick}
            className="btn btn-light text-start d-flex align-items-center btn-sm"
          >
            <MdArrowCircleRight
              className="me-2"
              size={20}
            />
            {item.label}
          </button>
        ))}

      </div>
    );
  }

  useEffect(() => { init(); }, []);
  useEffect(() => { appContext.setShowOverlayLoader(loading); }, [loading]);

  return (
    <>
      {renderShell(
        <div className="login-content py-5">
          {renderTopBrand()}

          {/* PHONE STEP */}
          {loginStep === 'identity' && (
            <>
              {renderCard(
                STR_ENTER_YOUR_PHONE_NUMBER[appContext.language],
                <>
                  
                  <div className="mb-4">

                    <label className="mb-2">
                      {STR_PHONE_NUMBER[appContext.language]}
                    </label>

                    <div className="input-group">

                      <span className="input-group-text">
                        +255
                      </span>

                      <input
                        id="phone-input"
                        className="form-control"
                        onChange={(e) =>
                          setPhone(_prev => {
                            const val = e.target.value.replace(/\D/g, '');
                            return val ? parseInt(val, 10) : "";
                          })
                        }
                        value={phone}
                        maxLength={10}
                        placeholder="7XX XXX XXX"
                        type="tel"
                        inputMode="numeric"
                      />

                    </div>

                  </div>

                  <div className="links-section">
                    {renderLinkRow([
                      { label: STR_FORGOT_PASSWORD[appContext.language], onClick: forgotPassword },
                      { label: STR_CHANGE_LANGUAGE[appContext.language], onClick: () => appContext.changeLanguage() },
                    ])}
                  </div>

                  <div className="button-section">
                    {renderPrimaryButton(STR_CONTINUE[appContext.language], phoneLogin)}
                  </div>
                </>,
                ""
              )}
            </>
          )}

          {/* OTP STEP */}
          {loginStep === 'otp' && (
            <>
              {renderCard(
                `${STR_ENTER_OTP[appContext.language]}!`,
                '',
                <>
                  <div className="mb-4">

                    <label className="mb-2">
                      OTP Code
                    </label>

                    <input
                      id="otp-input"
                      className="form-control text-center"
                      onChange={(e) =>
                        setOtp(
                          e.target.value
                            .replace(/[^0-9]/g, '')
                            .slice(0, 6)
                        )
                      }
                      value={otp}
                      maxLength={6}
                      placeholder="------"
                      type="text"
                      inputMode="numeric"
                      style={{
                        letterSpacing: "10px",
                        fontSize: "24px",
                        fontFamily: "FontBold"
                      }}
                    />

                  </div>

                  <div className="links-section">
                    {renderLinkRow([
                      { label: STR_CHANGE_PHONE[appContext.language], onClick: () => setLoginStep('identity') },
                      { label: STR_RESEND_OTP[appContext.language], onClick: resendOtp },
                      { label: STR_CHANGE_LANGUAGE[appContext.language], onClick: () => appContext.changeLanguage() },
                    ])}
                  </div>

                  <div className="button-section">
                    {renderPrimaryButton(STR_CONTINUE[appContext.language], otpLogin)}
                  </div>
                </>,
                ""
              )}
            </>
          )}
        </div>
      )}
    </>
  );
}